<template>
  <h2 v-if="!hideTitle" class="text-h4 mb-4">Summary of Steps</h2>
  <div class="border rounded mb-8">
    <div v-for="(step, index) in steps" :key="index">
      <div class="d-flex align-center">
        <div :data-testid="`summary-step-name-${index}`" class="w-50 mx-4 py-4">
          {{ step.name }}
        </div>
        <SoStatus
          v-if="step.completed"
          :data-testid="`summary-step-name-${index}-completed`"
          :status="new Status('normal', 'Completed')"
        />
        <SoStatus
          v-else
          :data-testid="`summary-step-name-${index}-incomplete`"
          :status="new Status('neutral', 'Incomplete')"
        />
      </div>
      <SoDivider v-if="index !== steps.length - 1" />
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { Status } from "@/types/Status"
  import SoStatus from "@/components/SoStatus.vue"
  import SoDivider from "@/components/SoDivider.vue"

  interface IFlowSummaryStep {
    name: string
    completed: boolean
  }

  export default defineComponent({
    components: {
      SoStatus,
      SoDivider,
    },
    inheritAttrs: false,
    props: {
      steps: {
        type: Array as PropType<IFlowSummaryStep[]>,
        required: true,
      },
      hideTitle: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        Status,
      }
    },
  })
</script>
